// ------------------------------------
// Constants
// ------------------------------------
export const PAYER_AUTH_REQUEST_POST = 'PAYER_AUTH_REQUEST_POST';
export const PAYER_AUTH_REQUEST_POST_SUCCESS = 'PAYER_AUTH_REQUEST_POST_SUCCESS';
export const PAYER_AUTH_REQUEST_POST_FAILURE = 'PAYER_AUTH_REQUEST_POST_FAILURE';
